import IIntegrationOptions from "../models/IIntegrationOptions";
import { IMenuItem } from "../models/IMenuItem";
import Services from "../services/Services";
import firstOrDefault from "./firstOrDefault";
import snackbarService from "../services/ui-messaging/SnackbarService";

const getIntegrationOptions = async (token: string, optSelect: (opts: IIntegrationOptions) => IMenuItem[]): Promise<IMenuItem[]> => {
  if (token) {
    const repo = await new Services().IntegrationRepository();
    const options = await repo.getOptions(token);
    return optSelect(options);
  }
  return [];
};

export default function loadIntegrationOptions(
  token: string,
  id: number | undefined,
  setItems: (items: IMenuItem[]) => void,
  setItem: (item: IMenuItem | undefined | null) => void,
  optSelect: (opts: IIntegrationOptions) => IMenuItem[],
) {
  const getOpts = async () => {
    const newOpts = await getIntegrationOptions(token, optSelect);
    if (newOpts) {
      setItems(newOpts);
      if (id !== undefined) {
        setItem(firstOrDefault(newOpts, o => o.ID === id, null));
      }
    } else {
      snackbarService.error("Error loading modules");
    }
  };
  getOpts();
}
